import React, { useContext, useState } from 'react';
import { toast } from 'react-toastify';
import CustomButton from '../../custom/custom-button/CustomButton';
import styles from "../common.module.scss";
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../../../context/auth.context';
import axios from 'axios';
import { configData } from '../../../services/api-config';

const FinishStepComponent = ({ data, updateStep }) => {
    const navigate = useNavigate();
    const auth = useContext(AuthContext);

    const [isLoading, setIsLoading] = useState(false);

    const handleLogin = () => {
        const payload = {
            username: data.userEmail ? data.userEmail.toLowerCase() : data.userEmail,
            password: data.password,
        }
        if (payload.username && payload.password) {
            setIsLoading(true);
            axios
                .get(configData.BASE_URL + 'api/v1/users/login', {
                    auth: payload,
                    withCredentials: true
                })
                .then((response) => {
                    if (response.status == 200) {
                        response.data.isAuthenticated = true;
                        auth.login(response.data.accessToken);
                        navigate("/profile")
                    }
                    setIsLoading(false);
                })
                .catch(error => {
                    toast.error("Ошибка при входе в личный кабинет" + error.message);
                    setIsLoading(false);
                });

        } else {
            toast.error('Ошибка при входе');
        }
    }

    return (
        <>
            <div className={styles.btns}>
                <CustomButton isFall text="Войти в личный кабинет" onClick={handleLogin} isLoading={isLoading} />
            </div>
        </>
    );
}

export default FinishStepComponent;
